import { render, staticRenderFns } from "./SalesExistingCustomerNumberDisplayer.vue?vue&type=template&id=c0854a72"
import script from "./SalesExistingCustomerNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesExistingCustomerNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports